export default __webpack_public_path__ + "static/media/431.4406d161.png";